module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/home/patient/dashboard"
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/home/patient/patientlist"
    }
  }, [_vm._v("病人库")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da3d9f00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/patient/patientmenu.vue
// module id = 1047
// module chunks = 2